import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { Container, Markup, Button } from '@landing/ui';
import { observer, cookies as cookiesStore } from 'store';
import { CONSENT_COOKIE_NAME, getCookieOptions } from 'define/cookies';
import data from './data.json';
import { getCookie, setCookie } from 'utils/cookie';
import { pushCookiePolicyEvent } from 'utils';

import * as styles from './CookiesPolicy.module.scss';

const BANNER = 'banner';

function CookiesPolicy() {
  const { description, accept } = data;
  const [consent, setConsent] = useState({ ad_storage: true, analytics_storage: true });

  const acceptCookies = () => {
    setCookie(CONSENT_COOKIE_NAME, JSON.stringify(consent), getCookieOptions());
    pushCookiePolicyEvent();
  };

  const onAccept = () => {
    localStorage.setItem(BANNER, 'seen');
    cookiesStore.setSeen(true);
  };

  useEffect(() => {
    const consentStatus = JSON.parse(getCookie(CONSENT_COOKIE_NAME));
    if (consentStatus) {
      setConsent(prev => ({ ...prev, ...consentStatus }));
    }
  }, []);

  useEffect(() => {
    if (!getCookie(CONSENT_COOKIE_NAME)) {
      acceptCookies();
    }
    if (!localStorage.getItem(BANNER)) {
      cookiesStore.setSeen(false);
    }
  }, []);

  return (
    <div className={cn(styles.wrapper, cookiesStore.seen && styles.hidden)}>
      <Container padding="Without" background="transparent">
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <div>
              <Markup tag="span" className={styles.text}>
                {description}
              </Markup>
            </div>
          </div>
          <Button className={styles.button} onClick={onAccept} fullWidthMobile>
            {accept}
          </Button>
        </div>
      </Container>
    </div>
  );
}

export default observer(CookiesPolicy);
